import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CancelInboundDeliveryMutation = graphql(/* GraphQL */ `
  mutation cancelInboundDelivery(
    $cancelInboundDeliveryInput: CancelInboundDeliveryInput!
  ) {
    cancelInboundDelivery(input: $cancelInboundDeliveryInput) {
      successOutput {
        ...SuccessOutput
      }
    }
  }
`);
